import React from 'react'
import { connect } from 'react-redux'
import {Flex, Tabs} from '/app/src/component'
import getQueryVariable from '/app/src/lib/urlparser'
import style from './style.css'

import {CustomerInfo} from '/app/src/container'
import Previous from '/app/src/layout/Dashboard/RightPanel/Conversation/Assigned/Previous'


class SearchCustomerRightPanel extends React.Component{
    constructor(props) {
        super(props);
        this._clickTab = this._clickTab.bind(this);

        this.state = {
            currentTab: 0
        }
    }

    _clickTab(index) {
        return ()=> {
            this.setState({
                currentTab: index
            })
        }
    }

    render() {
        const customers = this.props.customers;
        const id = getQueryVariable(this.props.location.search, 'id');
        const customer = customers.get(id);
        const currentTab = this.state.currentTab;
        if(!customer) {
            return (
                <Flex column grow center>
                    <h2> Ingen besökare vald </h2>
                </Flex>
            )
        }

        let tab0 = <CustomerInfo customer={customer}/>
        let tab1 = <Previous customer={customer}/>
        let tab0H = <img onClick={this._clickTab(0)} className={style.icons} src={currentTab === 0 ? '/images/CustomerInfoBlue.png' : '/images/CustomerInfoGrey.png'} alt='' />
        let tab1H = <img onClick={this._clickTab(1)}className={style.icons} src={currentTab === 1 ? '/images/HistoryBlueIcon.png' : '/images/HistoryGreyIcon.png'} alt=''/>



        return (
            <Tabs
                active={currentTab}
                header={[tab0H, tab1H]}
                body= {[tab0, tab1]}
            />
        )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        customers: state.getIn(['customer', 'items'])
    }
}

export default connect(mapStateToProps, null)(SearchCustomerRightPanel);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/RightPanel/Search/Customer/index.js